/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.supplyDemandBalance.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/supplyDemandBalance/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
